export default __webpack_public_path__ + "68281abe61ef2ca8f05389f5c40c0387.png";